import { Wheat, Shell, Egg, Fish, Sprout, Milk, Nut, Droplet, Leaf, Atom, Circle } from "lucide-react";

const ALLERGENS = [
  { id: "gluten", label: "Gluten", icon: Wheat },
  { id: "crustaceos", label: "Crustaceos", icon: Shell },
  { id: "huevos", label: "Huevos", icon: Egg },
  { id: "pescado", label: "Pescado", icon: Fish },
  { id: "cacahuetes", label: "Cacahuetes", icon: Circle },
  { id: "soja", label: "Soja", icon: Sprout },
  { id: "lacteos", label: "Lacteos", icon: Milk },
  { id: "frutos_cascara", label: "Frutos de Cascara", icon: Nut },
  { id: "apio", label: "Apio", icon: Leaf },
  { id: "mostaza", label: "Mostaza", icon: Droplet },
  { id: "sesamo", label: "Semillas de Sesamo", icon: Atom },
  { id: "sulfitos", label: "Sulfitos", icon: Atom },
  { id: "moluscos", label: "Moluscos", icon: Shell },
  { id: "altramuces", label: "Altramuces", icon: Sprout },
];

export default function AllergenSelector({ selectedAllergens = [], selectedTraces = [], onChange }) {
  const handleAllergenToggle = (allergenId) => {
    const newAllergens = selectedAllergens.includes(allergenId)
      ? selectedAllergens.filter(a => a !== allergenId)
      : [...selectedAllergens, allergenId];
    onChange({ allergens: newAllergens, traces: [] });
  };

  return (
    <div>
      <h4 className="font-semibold mb-3 text-gray-900">Alergenos</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {ALLERGENS.map((allergen) => {
          const Icon = allergen.icon;
          return (
            <label
              key={`allergen-${allergen.id}`}
              className="flex items-center gap-2 cursor-pointer hover:bg-gray-50 p-2 rounded"
            >
              <input
                type="checkbox"
                checked={selectedAllergens.includes(allergen.id)}
                onChange={() => handleAllergenToggle(allergen.id)}
                className="w-4 h-4 text-emerald-600 rounded focus:ring-emerald-500"
              />
              <Icon className="w-5 h-5 text-gray-600" />
              <span className="text-sm text-gray-700">{allergen.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
